import React from 'react';
import { Link } from 'react-router-dom';
import './JobApplicationPage.css';
import env from '../../utils/env';
import Header from "../../components/common/header/Header";
import Footer from "../../components/common/footer/Footer";

const JobApplicationPage = () => {

    return (
        <>
            <Header />

            <header className="mt-lg-5">
                <div className="container text-center">
                    <div className="os-badge mb-4 mx-auto">
                        <i className="fab fa-windows me-2"></i> Windows 11 or later
                    </div>
                    <h1 className="display-3 fw-bold mb-3 px-2">Ace your interview <br/><span className="text-primary">Get real-time answers</span></h1>
                    <p className="lead text-secondary mb-5 px-3 mx-auto" style={{maxWidth: "750px"}}>
                        The only invisible screen assistant that uses your resume and job description to provide natural, real-time coding and whiteboard solutions.
                    </p>
                    <div style={{justifyContent: 'center'}} className="d-flex mb-4">
                        <iframe
                            width="600"
                            height="340"
                            // src="https://www.youtube.com/embed/r__LGyFQyoA"
                            src="https://www.youtube.com/embed/y6IJbV-vTn4"
                            title="Download Demo"
                            allowFullScreen
                        />
                    </div>
                    <div className="row g-3 justify-content-center px-2">
                        <div className="col-4 col-md-3">
                            <div className="glass-card py-3">
                                <h3 className="fw-bold mb-0">431</h3>
                                <p className="text-secondary small mb-0">Success Stories</p>
                            </div>
                        </div>
                        <div className="col-4 col-md-3">
                            <div className="glass-card py-3">
                                <h3 className="fw-bold mb-0">42k</h3>
                                <p className="text-secondary small mb-0">YouTube Fans</p>
                            </div>
                        </div>
                        <div className="col-4 col-md-3">
                            <div className="glass-card py-3">
                                <h3 className="fw-bold mb-0">42k</h3>
                                <p className="text-secondary small mb-0">Social Community</p>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* <section id="features" className="py-5">
                <div className="container">
                    <div className="row g-4 align-items-center">
                        <div className="col-lg-6">
                            <div className="feature-icon"><i className="fas fa-eye-slash text-primary"></i></div>
                            <h2 className="fw-bold mb-3">Invisible Screen Overlay</h2>
                            <p className="text-secondary">Get answers on an invisible screen that never blocks your view. Perfect for maintaining eye contact while staying prepared.</p>
                            <div className="glass-card border-0 bg-white bg-opacity-10 mt-4">
                                <ul className="list-unstyled mb-0">
                                    <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> No window switching</li>
                                    <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> Clean, distraction-free view</li>
                                    <li><i className="fas fa-check text-primary me-2"></i> Zero interruption during coding</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="glass-card p-4 position-relative overflow-hidden">
                                <div className="rounded bg-dark border border-secondary p-4 text-center">
                                    <p className="text-secondary small mb-2 text-uppercase">Interviewer View</p>
                                    <h5 className="mb-0 text-white opacity-50">Just You & Your Face</h5>
                                </div>
                                <div className="mt-3 rounded border border-primary bg-primary bg-opacity-10 p-4 text-center">
                                    <p className="text-primary small mb-2 text-uppercase">Your View (Invisible Layer)</p>
                                    <p className="mb-0 fw-mono x-small text-primary">Generated Solution: O(n log n) approach...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            <section id="community" className="py-5">
                <div className="container text-center">
                    <h2 className="fw-bold mb-4">Join our Global Community</h2>
                    <p className="text-secondary mb-5">Connect with 42,000+ professionals from various industries.</p>
                    <div className="row justify-content-center g-4">
                        <div className="col-md-3">
                            <a
                                href="https://wa.me/16576307025?text=InterviewSupportAI"
                                target="_blank"
                                rel="noreferrer"
                                class="no-underline-link"
                            >
                                <div className="glass-card p-4">
                                    <i className="fab fa-whatsapp text-success fs-1 mb-3"></i>
                                    <h5 className='text-success'>WhatsApp</h5>
                                    <p className="small text-secondary">42k Followers</p>
                                </div>
                            </a>
                        </div>
                        <div className="col-md-3">
                            <a
                                href="https://www.youtube.com/channel/UCh3HLuGLeJAn2XO8RWCfKSQ"
                                target="_blank"
                                rel="noreferrer"
                                class="no-underline-link"
                            >
                                <div className="glass-card p-4">
                                    <i className="fab fa-youtube text-danger fs-1 mb-3"></i>
                                    <h5 className='text-danger'>YouTube</h5>
                                    <p className="small text-secondary">13k Subscribers</p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <section id="testimonials" className="py-5 bg-dark bg-opacity-50">
                <div className="container">
                    <h2 className="text-center fw-bold mb-5">Trusted by Professionals</h2>
                    <div className="row g-4">
                        <div className="col-md-6 col-lg-4">
                            <div className="glass-card h-100">
                                <p className="text-secondary italic mb-4">"The screenshot tool for whiteboarding is magical. It recognized the problem instantly and gave me a clear explanation I could share with the team."</p>
                                <div className="d-flex align-items-center">
                                    <div className="bg-primary rounded-circle me-3" style={{ width: '40px', height: '40px' }}></div>
                                    <div>
                                        <p className="fw-bold mb-0 small">Emily Carter</p>
                                        <p className="text-primary small mb-0">UX Lead</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="glass-card h-100">
                                <p className="text-secondary italic mb-4">"It understood the problem immediately and turned a rough sketch into a clear, shareable solution."</p>
                                <div className="d-flex align-items-center mt-5 pt-4">
                                    <div className="bg-primary rounded-circle me-3" style={{ width: '40px', height: '40px' }}></div>
                                    <div>
                                        <p className="fw-bold mb-0 small">Sarah Collins</p>
                                        <p className="text-primary small mb-0">Product Manager</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="glass-card h-100">
                                <p className="text-secondary italic mb-4">"Accurate, fast, and reliable—exactly what professionals need during technical discussions."</p>
                                <div className="d-flex align-items-center mt-5 pt-4">
                                    <div className="bg-primary rounded-circle me-3" style={{ width: '40px', height: '40px' }}></div>
                                    <div>
                                        <p className="fw-bold mb-0 small">Lucas Bennett</p>
                                        <p className="text-primary small mb-0">Solutions Architect</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer/>
        </>
    );
};

export default JobApplicationPage;